export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";